import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("circle", {
  cx: "7",
  cy: "14",
  r: "3"
}), React.createElement("circle", {
  cx: "11",
  cy: "6",
  r: "3"
}), React.createElement("circle", {
  cx: "16.6",
  cy: "17.6",
  r: "3"
})), 'ScatterPlotRounded');